/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Spin,
  Card,
  Row,
  Col,
  Tabs,
  Form,
  Input,
  DatePicker,
  Menu,
} from 'antd';
import {
  CheckCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons';
import { onAlert, onError } from 'utils/handlers';
import Table from 'components/Table';
import Select from 'components/Select';
import NumericInput from 'components/NumericInput';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  getDescuentoAsignacionMasiva,
  getDescuentosAsignacionMasiva,
  postDescuentoAsignacionMasiva,
  autorizarDescuentoAsignacionMasiva,
  descargarReporteDescuentosActivos,
  descargarReporteDescuentosSuspendidos,
  eliminarDescuentosAsignacionMasiva,
} from 'api/nominas/descuentos/descuentosAsignacionMasiva';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import { getEstadosGlobales } from 'api/catalogos';
import { getEmpleadosOptimized } from 'api/estructuraOrganizacional/empleados';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import moment from 'moment';
import { formatReceived } from 'utils/formatValues';
import TipoDescuento from 'components/Nominas/Descuentos/TipoDescuento';
import EmpleadosDescuentosMasivos from './EmpleadosDescuentosMasivos';

const { TabPane } = Tabs;

export const descuentoasignacionmasivaPermission = {
  permissionModel: 'descuentoasignacionmasiva',
  catalogsModels: [],
  tabsModels: [],
};

const DescuentoAsignacionMasiva = ({ permission }) => {
  const [tipoDescuentoSelected, setTipoDescuentoSelected] = useState({});
  const [tiposDeNominasEmpleados, setTiposDeNominasEmpleados] = useState([]);
  const [periodosDeNominasDetalles, setPeriodosDeNominasDetalles] = useState([]);
  const [periodosDeNominas, setPeriodosDeNominas] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [descuentos, setDescuentos] = useState([]);
  const [periodo, setPeriodo] = useState(null);
  const [importeDescuento, setImporteDescuento] = useState(0);
  const [estados, setEstados] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('descuento');
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [open, setOpen] = useState(false);
  const [disableForm, setDisableForm] = useState(false);
  const [descuentoEmpleadoMasivoAutorizado, setDescuentoEmpleadoMasivoAutorizado] = useState(false);
  const [descuentoEmpleadoMasivoInactivo, setDescuentoEmpleadoMasivoInactivo] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [estado, setEstado] = useState();
  const [form] = Form.useForm();

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _descuentos,
        _tiposDeNominasEmpleados,
        _periodosDeNominasDetalles,
        _periodosDeNominas,
        _empleados,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getConfiguracionDescuentos({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDeNominasEmpleados(),
        getPeriodosDeNominasDetalles(),
        getPeriodosDeNominas(),
        getEmpleadosOptimized(),
        getDescuentosAsignacionMasiva(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setDescuentos(_descuentos);
        setTiposDeNominasEmpleados(_tiposDeNominasEmpleados);
        setPeriodosDeNominasDetalles(_periodosDeNominasDetalles);
        setPeriodosDeNominas(_periodosDeNominas);
        setEmpleados(_empleados);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getDescuentosAsignacionMasiva();
    setData(formatReceived(_data));
    setLoading(false);
  };

  const onClickAdd = () => {
    setSelectedRowKeys([]);
    setDescuentoEmpleadoMasivoAutorizado(false);
    setDescuentoEmpleadoMasivoInactivo(false);
    setSelectedData([]);
    form.resetFields();
    const now = moment();
    form.setFieldValue('fecha', now);
    setOpen(true);
  };

  const onClickEdit = async (responseData = null) => {
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _asignacion = await getDescuentoAsignacionMasiva(match.id);

    setEstado(_asignacion.estados_globales);

    const _tipoDeNomina = tiposDeNominasEmpleados.find((e) => e.id === _asignacion?.tipo_de_nomina_empleado);
    // eslint-disable-next-line no-unused-expressions
    _tipoDeNomina.habilitado ? setIsBlocked(false) : setIsBlocked(true);

    setTimeout(() => {
      if (_asignacion) {
        form.resetFields();
        setDisableForm(true);
        form.setFieldsValue({
          ...formatReceived(_asignacion),
          empleados_asignados: _asignacion?.estados_globales === ESTATUS_AUTORIZADO ? _asignacion?.empleados_asignados : null,
        });

        setPeriodo(_asignacion?.tipo_de_nomina_empleado);
        const _descuento = descuentos.find((item) => item?.id === _asignacion?.descuento);
        const descuentoParaEstado = { ..._descuento };
        if (descuentoParaEstado?.acreedor && typeof descuentoParaEstado.acreedor === 'object') {
          descuentoParaEstado.acreedor = descuentoParaEstado.acreedor.id;
        }
        setTipoDescuentoSelected(descuentoParaEstado);
        if (_asignacion?.estados_globales === ESTATUS_AUTORIZADO) {
          setDescuentoEmpleadoMasivoAutorizado(true);
        } else {
          setDescuentoEmpleadoMasivoAutorizado(false);
        }

        if (_asignacion?.estados_globales === ESTATUS_INACTIVO) {
          setDescuentoEmpleadoMasivoInactivo(true);
        } else {
          setDescuentoEmpleadoMasivoInactivo(false);
        }

        if (_asignacion?.no_de_periodos_de_descuento && _asignacion?.importe_base > 0) {
          const _importeDescuento = _asignacion.importe_base / _asignacion.no_de_periodos_de_descuento;
          setImporteDescuento(_importeDescuento.toFixed(2));
        } else {
          setImporteDescuento(((_asignacion?.importe_base || 0)).toFixed(2));
        }

        setSelectedRowKeys([_asignacion.id]);
        setSelectedData([_asignacion]);
        setOpen(true);
      }
    });
  };

  const onClickDelete = () => setVisibleAlert(true);

  const onCancel = () => {
    setOpen(false);
    setVisibleAlert(false);
    setVisibleAutorizar(false);
    setSelectedRowKeys([]);
    setSelectedData([]);
    setTipoDescuentoSelected({});
    setImporteDescuento([]);
    setPeriodo(null);
    setCurrentTabKey('descuento');
    setIsBlocked(false);
    setDisableForm(false);
  };

  const onChangeTipoDeNominaEmpleado = (value) => {
    form.resetFields(['periodo_de_nomina_detalle']);
    if (value) {
      const _tipoNominaEmpleado = tiposDeNominasEmpleados.find((e) => e.id === value);
      if (_tipoNominaEmpleado.habilitado) {
        setPeriodo(value);
      } else {
        onAlert(`El Tipo de Nómina Empleado ${_tipoNominaEmpleado?.descripcion} se encuentra cerrado`);
        form.resetFields(['tipo_de_nomina_empleado']);
      }
    } else {
      setPeriodo(null);
    }
  };

  const onPrint = async (descargarFunc, title) => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const pdf = await descargarFunc(key);
      const asignacion = data.find((item) => item.id === key);
      if (pdf) {
        const blob = new Blob([pdf], {
          type: 'application/pdf',
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${title}-${asignacion?.clave}`;
        link.click();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleSelectAll = (selected, selectedRows) => {
    setSelectedRowKeys(selectedRows.map((row) => row.id));
    setSelectedData(selectedRows);
  };

  const onFinish = async (_values, _continue = false) => {
    setLoading(true);
    try {
      await form.validateFields();
      const tipoNominaSeleccionado = tiposDeNominasEmpleados.find((e) => e?.id === form.getFieldValue('tipo_de_nomina_empleado'));
      let periodicidad_de_pago = tipoNominaSeleccionado?.periodicidad_de_pago;
      if (typeof periodicidad_de_pago === 'object' && periodicidad_de_pago !== null) {
        periodicidad_de_pago = periodicidad_de_pago.id;
      }
      const fecha = form.getFieldValue('fecha').format('DD-MM-YYYY');
      const values = {
        ...form.getFieldsValue(),
        periodicidad_de_pago,
        fecha,
      };
      delete values.empleados_asignados;
      const saved = await postDescuentoAsignacionMasiva(values);
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          setSelectedData([saved]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onDelete = async () => {
    try {
      setLoading(true);
      const mappedSelectedRowKeys = selectedRowKeys.map((val) => ({
        id: val,
      }));
      const saved = await eliminarDescuentosAsignacionMasiva(mappedSelectedRowKeys);
      if (saved) {
        await fetchData();
      }
    } catch (err) {
      setLoading(false);
      onError(err, setLoading);
    }
    setSelectedRowKeys([]);
    setVisibleAlert(false);
  };

  const onAutorizar = async () => {
    try {
      setLoading(true);
      const autorizados = await Promise.all(selectedRowKeys.map((id) => autorizarDescuentoAsignacionMasiva(id)));
      if (autorizados.some((item) => item?.estados_globales === ESTATUS_AUTORIZADO)) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (row) => {
    if (selectedRowKeys.includes(row.id)) {
      setSelectedRowKeys(selectedRowKeys.filter((e) => e !== row.id));
      setSelectedData(selectedData.filter((item) => item?.id !== row.id));
    } else {
      setSelectedRowKeys([...selectedRowKeys, row.id]);
      setSelectedData([...selectedData, row]);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onSelectAll: handleSelectAll,
    type: 'checkbox',
  };

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Fecha de Asignación',
      dataIndex: 'fecha',
      key: 'fecha',
      width: 300,
      render: (value) => (value
        ? new Date(value).toLocaleDateString('es-MX', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
        : ''),
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 300,
      render: (val) => tiposDeNominasEmpleados.find((e) => e?.id === val)?.descripcion,
    },
    {
      titleText: 'Concepto de Descuento',
      dataIndex: 'descuento',
      key: 'descuento',
      width: 300,
      render: (val) => {
        const _descuento = descuentos.find((e) => e?.id === val);
        return _descuento ? `${_descuento?.clave} - ${_descuento?.concepto}` : '';
      },
    },
    {
      titleText: 'Periodo de Nómina Inicial',
      dataIndex: 'periodo_de_nomina_detalle',
      key: 'periodo_de_nomina_detalle',
      width: 300,
      render: (val) => {
        const _periodo = periodosDeNominasDetalles.find((e) => e?.id === val);
        return _periodo ? `${_periodo?.numero_de_nomina} (${_periodo?.fecha_inicial} al ${_periodo?.fecha_final})` : '';
      },
    },
    {
      titleText: 'No. de Empleados',
      dataIndex: 'empleados_asignados',
      key: 'empleados_asignados',
      width: 200,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => {
        const _estatus = estados.find((e) => e?.id === val);
        return _estatus ? _estatus?.descripcion : '';
      },
    },
  ];

  const reportsMenu = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Descuentos Suspendidos',
          text: 'Descuentos Suspendidos',
          icon: <MinusCircleOutlined />,
          onClick: () => onPrint(descargarReporteDescuentosSuspendidos, 'Descuentos-Suspendidos'),
        },
        {
          key: 2,
          label: 'Descuentos Activos',
          text: 'Descuentos Activos',
          icon: <CheckCircleOutlined />,
          onClick: () => onPrint(descargarReporteDescuentosActivos, 'Descuentos-Activos'),
        },
      ]}
      disabled={selectedRowKeys.length !== 1 || selectedData[0]?.estados_globales !== ESTATUS_AUTORIZADO}
    />
  );

  const requiredRule = {
    required: true,
    message: 'El campo es requerido.',
  };

  const rules = {
    required: [requiredRule],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            controls={{
              onClickAdd,
              onClickEdit,
              onClickDelete,
            }}
            customActions={[
              {
                onClick: () => setVisibleAutorizar(true),
                permission: { model: 'descuentoasignacionmasiva', action: 'autorizar' },
                icon: <CheckCircleOutlined />,
                text: 'Autorizar',
                disabledBySelection: true,
                disabled: selectedData.some((item) => item?.estados_globales !== ESTATUS_ACTIVO),
                className: 'success',
              },
            ]}
            disableDelete={selectedData.some((item) => item?.estados_globales !== ESTATUS_ACTIVO)}
            allowReports
            reportsMenu={reportsMenu}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            allowDoubleClick={false}
            allowExportPDF={false}
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Descuento`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                // allowSave={!disableForm}
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
              initialValues={{
                estados_globales: ESTATUS_ACTIVO,
              }}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="clave"
                    label="Clave"
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha"
                    label="Fecha de Asignación"
                  >
                    <DatePicker
                      format="DD/MM/YYYY"
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_nomina_empleado"
                    label="Tipo de Nómina Empleado"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      labelProp="descripcion"
                      dataSource={tiposDeNominasEmpleados}
                      onChange={onChangeTipoDeNominaEmpleado}
                      disabled={disableForm || isBlocked}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="descuento"
                    label="Concepto de Descuento"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={descuentos}
                      render={(val) => `${val?.clave} - ${val?.concepto}`}
                      onChange={(val) => {
                        const _descuento = descuentos.find((e) => e?.id === val);
                        setTipoDescuentoSelected(_descuento);
                      }}
                      disabled={disableForm || isBlocked}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <NumericInput
                    name="empleados_asignados"
                    label="No. de Empleados"
                    allowZero
                    disabled
                  />
                </Col>
                {/* <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo_de_nomina_detalle"
                    label="Periodo de Nómina Inicial"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosDeNominasDetalles.filter((e) => e?.periodo_de_nomina === periodo)}
                      render={(val) => `${val?.numero_de_nomina} (${val?.fecha_inicial} al ${val?.fecha_final})`}
                      disabled={disableForm || isBlocked}
                    />
                  </Form.Item>
                </Col> */}
                <Col xs={24} sm={24} md={16}>
                  <Form.Item
                    name="aplica_carga"
                    label="¿Aplica para Carga?"
                    rules={rules.required}
                    hasFeedback
                  >
                    <Select
                      trueFalse
                      disabled={isBlocked}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    label="Estatus"
                  >
                    <Select
                      dataSource={estados}
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Tabs
                activeKey={currentTabKey}
                onChange={setCurrentTabKey}
                type="card"
              >
                <TabPane
                  tab="Descuento"
                  key="descuento"
                  forceRender
                >
                  <TipoDescuento
                    form={form}
                    selectedRowKeys={selectedRowKeys}
                    tipoDescuento={tipoDescuentoSelected}
                    importeDescuento={importeDescuento}
                    setImporteDescuento={setImporteDescuento}
                    periodo={periodo}
                    descuentoEmpleadoAutorizadoInactivo={descuentoEmpleadoMasivoAutorizado
                    || descuentoEmpleadoMasivoInactivo}
                    isBlocked={isBlocked}
                    esAsignacionMasiva
                  />
                </TabPane>
                <TabPane
                  tab="Empleados"
                  key="empleados"
                  forceRender
                  disabled={!selectedRowKeys.length}
                >
                  <EmpleadosDescuentosMasivos
                    descuentoAsignacionMasiva={selectedRowKeys[0]}
                    empleados={empleados}
                    descuentoEmpleadoMasivoAutorizado={descuentoEmpleadoMasivoAutorizado}
                    descuentoEmpleadoMasivoInactivo={descuentoEmpleadoMasivoInactivo}
                    tipoDescuento={tipoDescuentoSelected}
                    permission={permission}
                    isBlocked={isBlocked}
                    estatus={estado}
                  />
                </TabPane>
              </Tabs>
            </Form>
          </Card>
        )}
        <ModalDelete
          content={selectedRowKeys.length > 1
            ? `${selectedRowKeys.length} Asignaciones de Descuentos`
            : `Asignación de Descuento ${data.find((item) => item?.id === selectedRowKeys[0])?.clave}`}
          onDelete={onDelete}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onAutorizar}
          onFinishText="Autorizar"
          onFinishIcon={<CheckCircleOutlined />}
          onCancel={() => setVisibleAutorizar(false)}
          title="Confirmación"
          contentTitle={selectedRowKeys.length > 1
            ? `Autorizar ${selectedRowKeys.length} Asignaciones de Descuentos`
            : `Autorizar la Asignación de Descuento ${data.find((item) => item?.id === selectedRowKeys[0])?.clave}`}
          subMessage
          open={visibleAutorizar}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default DescuentoAsignacionMasiva;
